import { Fragment } from 'react';
import { Tag } from '../../Tags/Tag';
import { ProgressBar } from './ProgressBar';
import './ProgressChart.css';

/**
 * 
 * @param {object} data - Expected object {[label: string]: {
 *  max, min, value, color, colorGRadient, solidOverflow, showValueLabel, 
 * }}
 * @returns 
 */
export const ProgressChart = ({ data, title, subtitle, note, barSettings }) => {
  return (<div className='progress-chart-component'>
    {(title || subtitle || note) &&<div className='progress-chart-header'>
      {(title || subtitle) && <div className='chart-title'>
        <b>{title}</b>
        <span>{subtitle}</span>
      </div>}
      {note ?? ''}
    </div>}
    <div className='progress-table'>
      {
        Object.entries(data ?? {}).map(([label, progressBarProps]) => <Fragment key={label}> <span>{label}</span> <ProgressBar key={label} {...{...progressBarProps, ...(barSettings ?? {})}} /></Fragment>)
      }

    </div>
  </div>)
}
